import {
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  CardMedia,
  Tooltip,
  Paper,
} from "@mui/material";
import {
  Add as AddIcon,
  HelpOutlineOutlined as HelpIcon,
  DragIndicator as DragIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import CommanModalForConformation from "../../../Common_Components/CommanModalForConformation";
import { useState } from "react";

export const Timeline = ({
  timelineItems,
  onReorder,
  onDeleteItem,
  onAddToTimeline,
  onClickItem,
  activeItem,
  activeProvider
}) => {

const PROVIDERS = {
  HEYGEN: "heygen",
  VEO2: "veo2",
};
// console.log("timelineItems",timelineItems)
const {setVeo2Videos, veo2Videos} = useWorkspace()
const [open, setOpen] = useState(false)
const [loading, setLoading] = useState(false)
const [deleteVideoId, setDeleteVideoId] = useState(null)
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    onReorder(result.source.index, result.destination.index);
  };

const DeleteVideoFromVeo = () => {
  setLoading(true)
  // Delete logic
  setVeo2Videos(prevVideos => {
    const videoToDelete = prevVideos.find(video => video.id === deleteVideoId);
    
    // Clean up blob URL
    if (videoToDelete?.url?.startsWith('blob:')) {
      URL.revokeObjectURL(videoToDelete.url);
    }
    
    return prevVideos.filter(video => video.id !== deleteVideoId);
  });

  // Update active video
  const deletedIndex = veo2Videos.findIndex(video => video.id === deleteVideoId);
  const currentActiveVideo = activeItem; // or get from state
  
  onClickItem(prev => {
    if (prev === deletedIndex) {
      // If deleting the active video, go to previous or first
      return Math.max(0, deletedIndex - 1);
    } else if (prev > deletedIndex) {
      // If deleting a video before active, adjust index
      return prev - 1;
    }
    return prev;
  });

  handleCancel()
  setLoading(false)
  setDeleteVideoId(null)
};

const handleCancel = () => {
  setOpen(false)
}

const OpenDailogBoxForConfirmation = (id) => {
  setOpen(true)
  setDeleteVideoId(id)
}

  return (
    <Paper
      elevation={2}
      sx={{
        position: { xs: "fixed", sm: "absolute" },
        left: { xs: 0, sm: "", md: "" },
        top: { xs: "32px", sm: "32px" },
        width: {
          xs: "90%",
          sm: "90%",
          md: "90%",
        },
        height: { xs: "140px", sm: "160px", md: "19vh" },
        maxHeight:"124px",
        bgcolor: "#1F233E",
        overflow: "auto",
        zIndex: { xs: 90, sm: "auto" },
        // marginTop:4,
        // marginLeft:"2.00rem",
        border:""
      }}
    >
      {/* Rulers  */}
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          mb: 1,
          paddingLeft: activeProvider === PROVIDERS.HEYGEN ? 9 : 2,
          top: 10,
        }}
      >
        {Array.from({ length: 9 }, (_, i) => (
          <Typography
            key={i}
            variant="caption"
            sx={{
              color: "#555",
              minWidth: activeProvider === PROVIDERS.HEYGEN ? 155 : 100,
              textAlign: "center",
            }}
          >
             {  activeProvider === PROVIDERS.HEYGEN ? `${(i + 1) * 20}S` : `${(i + 1) * 2}S`}
          </Typography>
        ))}
      </Box>

      {/* Question Mark */}
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Tooltip
          title={
            "Time Shown are Estimate and are calculated relative to previous attempts of video generation, which may not be 100% accurate."
          }
        >
          <IconButton size="small" sx={{ color: "#707070" }}>
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Timeline Items */}
      <Box sx={{ position: "absolute", top: 30 }}>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="timeline" direction="horizontal">
            {(provided, snapshot) => (
              <Box
                ref={provided.innerRef}
                {...provided.droppableProps}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: 70,
                  border: snapshot.isDraggingOver
                    ? "2px dashed #00a1ff"
                    : "2px dashed transparent",
                  borderRadius: 1,
                  p: 1,
                  transition: "border-color 0.3s ease",
                }}
              >
                {timelineItems?.length === 0 ? (
                  <Box
                    sx={{ flex: 1, textAlign: "center", color: "#666", py: 2 }}
                  >
                    <Typography variant="body2">
                      create your video timeline
                    </Typography>
                  </Box>
                ) : (
                  timelineItems?.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={`${item.id}`}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <Card
                          onClick={() => onClickItem(index)}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          sx={{
                            minWidth: activeProvider === PROVIDERS.HEYGEN ?  { xs: 80, sm: 100 } : {sm:350},
                            height: { xs: 60, sm: 80 },
                            mr: 1,
                            bgcolor: snapshot.isDragging
                              ? "#2a2f4a"
                              : "#1f233e",
                            cursor: "grab",
                            "&:active": { cursor: "grabbing" },
                            position: "relative",
                            overflow: "hidden",
                            borderRadius: 2,
                            transform: snapshot.isDragging
                              ? "rotate(5deg)"
                              : "none",
                          }}
                        >
                        {activeProvider === PROVIDERS.HEYGEN ?  
                        <CardMedia
                            component="img"
                            src={item.thumbnail}
                            alt="Avatar Image"
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              zIndex: 1,
                              pointerEvents: "none",
                            }}
                          /> :
                          <video
                            src={item.url}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                            muted
                            preload="metadata"
                            />
                        }
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background:
                                index === activeItem
                                  ? "linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 208, 255, 0.5))"
                                  : "linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))",
                              zIndex: 2,
                            }}
                          />
                          <CardContent
                            sx={{
                              p: 1,
                              height: "100%",
                              position: "relative",
                              zIndex: 3,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <DragIcon
                                sx={{
                                  color: "#666",
                                  fontSize: 16,
                                  mr: 0.5,
                                }}
                              />
                              {/* <Typography
                                variant="caption"
                                sx={{
                                  color: "white",
                                  fontSize: 10,
                                  marginLeft: "25%",
                                }}
                              >
                                {index}
                              </Typography> */}
                            </Box>
                            {/* <Typography
                              variant="caption"
                              sx={{
                                color: "#ccc",
                                fontSize: 10,
                                marginLeft: "40%",
                              }}
                            >
                              {item.duration}s
                            </Typography> */}
                             <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                onDeleteItem(item.id);
                              }}
                              sx={{
                                position: "absolute",
                                top: 2,
                                right: 2,
                                color: "#ff6b6b",
                                fontSize: 12,
                                p: 0.5,
                              }}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </CardContent>
                          { 
                          activeProvider !== PROVIDERS.HEYGEN &&
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              OpenDailogBoxForConfirmation(item.id);
                            }}
                            sx={{
                              position: "absolute",
                              top: 2,
                              right: 2,
                              color: "#ff6b6b",
                              fontSize: 12,
                              p: 0.5,
                              zIndex:50
                            }}
                          >
                            <DeleteIcon fontSize="inherit" />
                          </IconButton>
                       
                          }
                        </Card>
                      )}
                    </Draggable>
                  ))
                )
                }
                {provided.placeholder}
              </Box>
            )}
          </Droppable>
        </DragDropContext>
      </Box>

      {/* Add Timeline Item Button */}
     {
        activeProvider === PROVIDERS.HEYGEN ? 
        <Tooltip title="Add new timeline item">
        <IconButton
          onClick={onAddToTimeline}
          sx={{
            position: "absolute",
            right: 20,
            top: "50%",
            transform: "translateY(-50%)",
            bgcolor: "#1D1D1D",
            color: "#FFBB00",
            "&:hover": {
              bgcolor: "#2D2D2D",
            },
          }}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>
        : null
     } 
     <CommanModalForConformation open={open} modalTitle={"Delete Video"} modalMessage={"Are you sure you want to Delete this video?"} handleConfirm={DeleteVideoFromVeo} handleCancel={handleCancel} confirmTitle={"Yes, delete video"} loading={loading}/>
    </Paper>
  );
};